export const generatePertage = () => {
  var pertages = [];
  for (let i = 0; i <= 100; i = i + 5) {
    pertages.push({ value: i, label: `${i} %` });
  }
  return pertages;
};
